export default __webpack_public_path__ + "static/media/DNo.37-1.8780c867.jpg";